import RelatedFileQa from './RelatedFileQa.component';

export default RelatedFileQa;